import { DatePicker } from 'antd';
import { useField } from 'formik';
import dayjs from 'dayjs';
import { useEffect } from 'react';

const DateInput = (props) => {
  const { placeholder, name, showTime = false, size = 'default', picker = '' } = props;
  const [field, meta, helpers] = useField(name);
  const { setValue } = helpers;

  const handleChange = (value) => {
    setValue(value ? value.toISOString() : null);
  };

  const handleBlur = () => {
    helpers.setTouched(true);
  };

  useEffect(() => {
    if (field.value) setValue(field.value);
  }, [field.value, setValue]);

  return (
    <div className="form-group" style={{ width: '100%' }}>
      <DatePicker
        size={size}
        id={name}
        name={name}
        style={{
          width: '100%',
        }}
        placeholder={placeholder}
        showTime={showTime}
        onChange={handleChange}
        onBlur={handleBlur}
        status={meta.touched && meta.error ? 'error' : ''}
        picker={picker}
        value={field.value ? dayjs(field.value) : null}
      />
    </div>
  );
};

export default DateInput;
